import React from 'react';
import { apiFetch } from '../../utils'
export class FacebookLogin extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // Load the Facebook SDK
        window.FB.init({
            appId: '24075831558717479',
            cookie: true,
            xfbml: true,
            version: 'v23.0',
        });

        // Load SDK script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    handleFBLoginBackend(accessToken, userID) {
                    apiFetch('auth/facebook', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ accessToken, userId: userID }),
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data) {
                                this.props.onLoginSuccess?.(data);
                            } else {
                                console.error('Backend login failed.');
                                alert(data?.message);
                            }
                        });
    }

    handleFBLogin = () => {
        if (!window.FB) {
            alert("Facebook SDK not loaded yet.");
            return;
        }

        window.FB.getLoginStatus((response) => {
            if (response.status === 'connected') {
            const { accessToken, userID } = response.authResponse;
                window.FB.api('/me', { fields: 'name,email', access_token: accessToken }, () => { this.handleFBLoginBackend(accessToken, userID) });
            } else {
                window.FB.login((response) => {
                    if (response.authResponse) {
            const { accessToken, userID } = response.authResponse;
                        window.FB.api('/me', { fields: 'name,email' }, () => this.handleFBLoginBackend(accessToken, userID));
            } else {
                alert("Facebook login was cancelled or failed.");
            }
        }, { scope: 'public_profile,email' });
            }
        });
    }

    render() {
        return (
            <button onClick={this.handleFBLogin} className="btn btn-primary">
                Login with Facebook
            </button>
        );
    }
}